import { Pipe, PipeTransform } from '@angular/core';
/*
 * Camel case pipe
 * Usage: {{ someText | camelCase }}
 * Example: 'hello world' => 'helloWorld'
 */
export const camelCase = (value: string): string => {
  if (value) {
    return value
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word;
        }
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join('');
  }

  return value;
};

@Pipe({ name: 'camelCase' })
export class CamelCasePipe implements PipeTransform {
  transform(value: string) {
    return camelCase(value);
  }
}
